__turbopack_context__.v({
  "section": "ArticleModuleHeroSidebarSection-module-scss-module__eQbKoa__section",
  "title": "ArticleModuleHeroSidebarSection-module-scss-module__eQbKoa__title",
});
